import DetailPreview from './DetailPreview';

export default DetailPreview;
